export const url = "https://laderpungen.se/motion/backend/";
export const password = "sexnoll";



// WEBPACK FOOTER //
// ./src/constants/config.js